import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/TeacherProfileNav.css"; // Link to your CSS file

const TeacherProfileNav = ({
  isSearching = false,
  setIsSearching,
  setSearchQuery,
  isDownloadPage = false,
}) => {
  const [activePage, setActivePage] = useState("videos");
  const navigate = useNavigate();
  const location = useLocation();

  // Update activePage based on current path
  useEffect(() => {
    if (location.pathname === "/teacher/demographic-report") {
      setActivePage("manage");
    } else if (location.pathname === "/teacher") {
      setActivePage("videos");
    } else {
      setActivePage("search");
    }
  }, [location.pathname]);

  const handlePageChange = (page) => {
    setActivePage(page);
    if (!isDownloadPage) {
      if (page === "manage") {
        navigate("/teacher/demographic-report");
      } else if (page === "videos") {
        navigate("/teacher");
      } else if (page === "search") {
        //do nothing
        //navigate("/teacher");
      }
    }
  };

  return (
    <div>
      <nav className="profile-nav">
        {!isSearching && (
          <button
            className={`nav-button ${
              activePage === "videos" ? "active" : "inactive"
            }`}
            onClick={() => handlePageChange("videos")}
          >
            My Videos
          </button>
        )}

        {isSearching && (
          <button
            className={`nav-button ${
              activePage === "search" ? "active" : "inactive"
            }`}
            onClick={() => {
              setSearchQuery("");
              setIsSearching(false);
              handlePageChange("videos");
            }}
          >
            My Videos
          </button>
        )}

        <button
          className={`nav-button ${
            activePage === "manage" ? "active" : "inactive"
          }`}
          onClick={() => handlePageChange("manage")}
        >
          Manage
        </button>

        {/* Conditionally render the Search Results button when isSearching is true */}
        {isSearching && (
          <button className="nav-button active">Search Results</button>
        )}
      </nav>
    </div>
  );
};

export default TeacherProfileNav;
